export const Mode = Object.freeze({
    LOCAL: 'local',
    REMOTE: 'remote'
});